module.exports = __webpack_public_path__ + "img/continuous.d3a99acb.png";